import smoothscroll from 'smoothscroll-polyfill';

import initHamburger from './misc/initHamburger';
import initSliders from './misc/initSliders';
import initVisualEffects from './misc/initVisualEffects';
import handleFooterCollapsible from './misc/handleFooterCollapsible';
import handleTabs from './misc/handleTabs';
import handleAccordionStateClass from './misc/handleAccordionStateClass';
import handleStickyNav from './misc/handleStickyNav';
import handleNavCollapseBlur from './misc/handleNavCollapseBlur';
import '../scss/main.scss';

// Polyfills
smoothscroll.polyfill();

// Modules
initHamburger();
initSliders();
initVisualEffects();
handleFooterCollapsible();
handleTabs();
handleAccordionStateClass();
handleStickyNav();
handleNavCollapseBlur();

// Fix Firefox scrolling bug
if (location.hash) {
  window.addEventListener('load', function () {
    const target = location.hash.split('#')[1];
    if (target.length) {
      document.querySelector(`#${target}`)?.scrollIntoView();
    }
  });
}

